// Copyright 2025 Imprivata, Inc. All rights reserved.

import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import AddUsersImg from '../../assets/icons/add_user.svg?react';
import ArrowDownImg from '../../assets/icons/arrow-down.svg?react';

import './SelectUsers.less';

const TRANSLATION_ROOT = 'portal.settings.identity-users';

export type SelectUsersOption = { key: string; label: string; onClick?: () => void };

type SelectUsersProps = { options: SelectUsersOption[] };

const SelectUsers = ({ options }: SelectUsersProps) => {
  const { t } = useTranslation();

  const items: MenuProps['items'] = options.map(option => ({
    key: option.key,
    label: option.label,
    onClick: option.onClick,
  }));

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName="select-users-dropdown"
    >
      <div className="select-users">
        <div className="select-users-trigger">
          <span className="select-users-trigger-prefix">
            <AddUsersImg />
          </span>
          <span className="select-users-trigger-label">
            {t(`${TRANSLATION_ROOT}.add-user-dropdown`)}
          </span>
          <span className="select-users-trigger-arrow">
            <ArrowDownImg />
          </span>
        </div>
      </div>
    </Dropdown>
  );
};

export default SelectUsers;
